import React, { useState } from 'react';

import Page from 'components/Page';
import { Button, Layout } from 'antd';
import Table from 'components/Table';
import { useMutation, useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { DeleteOutlined } from '@ant-design/icons';
import SegmentEditor from './SegmentEditor';

const QUERY = gql`
  query Segments {
    segments {
      id
      title
      createdBy {
        id
        email
      }      
    }
  }
`;

const REMOVE_SEGMENT = gql`
  mutation RemoveSegment($id: ID!) {
    removeSegment(id: $id) {
      id
    }
  }
`;

const columns = [{
  title: 'Title',
  dataIndex: 'title',
}, {
  title: 'Created By',
  dataIndex: ['createdBy', 'email'],
}];

const PredefinedSegments = () => {
  const { data, loading, refetch } = useQuery(QUERY);
  const [removeSegment] = useMutation(REMOVE_SEGMENT);
  const [segmentId, setSegmentId] = useState(false);

  const onSegmentEditorDone = () => {
    refetch();
    setSegmentId(false);
  };

  const onRemoveSegment = async (id) => {
    await removeSegment({ variables: { id } });
    refetch();
  };

  const actions = record => [
    <Button key="edit" onClick={() => setSegmentId(record.id)}>Edit</Button>,
  ];

  const actionsMenuItems = (record) => [
    {
      key: 'remove',
      label: 'Remove',
      danger: true,
      icon: <DeleteOutlined />,
      onClick: () => onRemoveSegment(record.id),
    },
  ];

  return (
    <Layout>
      <Page>
        <Page.Header
          title="Predefined segments"
          extra={<Button type="primary" onClick={() => setSegmentId(true)}>Create Segment</Button>}
        />
        <Page.Content>
          <Table columns={columns} dataSource={data?.segments} loading={loading} actions={actions} actionsMenuItems={actionsMenuItems} />
        </Page.Content>

        <SegmentEditor open={!!segmentId} onCancel={() => setSegmentId(false)} onDone={onSegmentEditorDone} segmentId={segmentId !== true ? segmentId : null} />
      </Page>
    </Layout>
  );
};

export default PredefinedSegments;
